import freeEmailDomains from '../utils/free-email-domains';

/**
 * Provides an expected format for working with paths.
 *
 * @param {String} valid email address
 *
 * @return {Boolean} true if free email domain
 */
export function detectFreeEmailDomain(email) {
  if (email) {
    var emailParts = email.split("@");
    if (emailParts.length != 2){
      return true;
    }else {
      var emailDomain = emailParts[1].toLowerCase();
      return freeEmailDomains.some(
          function(domain){
            if (domain == emailDomain) return true;
          });
    }
  }
}